import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/sign-in.css";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const Sign_up = () => {
	return (
		<>
			{/* Header starts here */}
			<AuthHeader />
			{/* Header ends here */}
			{/* sign in starts here */}
			<section className="sign-in">
				<div className="container">
					<div className="row ">
						<div className="col-lg-4">
							<div className="sign-in-form-wrapper">
								<div className="heading-wrapper">
									<h2>Sign Up As A Buyer</h2>
									<p>
										Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
										diam nonumy aliquyam erat
									</p>
								</div>
								<div className="sign-form-wrapper">
									<form action="/MyProfile">
										<div className="form-group row">
											<div className="col-lg-6">
												<label htmlFor="">First Name</label>
												<input
													className="form-control"
													type="text"
													placeholder="John"
												/>
											</div>
											<div className="col-lg-6">
												<label htmlFor="">Last Name</label>
												<input
													className="form-control"
													type="text"
													placeholder="Doe"
												/>
											</div>
										</div>
										<div className="form-group">
											<label htmlFor="">Email Address</label>
											<input
												className="form-control"
												type="email"
												placeholder="John Doe@gmail.com"
											/>
										</div>
										<div className="form-group">
											<label htmlFor="">Phone Number</label>
											<input
												className="form-control"
												type="email"
												placeholder="Phone Number"
											/>
										</div>
										<div className="form-group">
											<label htmlFor="">Referral code (Optional)</label>
											<input
												className="form-control"
												type="email"
												placeholder="Referral code"
											/>
										</div>
										<div className="form-group">
											<label htmlFor="">Password</label>
											<input
												className="form-control"
												type="Password"
												placeholder="**********"
											/>
										</div>
										<div className="form-group">
											<label htmlFor="">Confirm Password</label>
											<input
												className="form-control"
												type="Password"
												placeholder="**********"
											/>
										</div>
										<div className="form-group">
											<button className="btn" type="submit">
												Sign Up
											</button>
										</div>
										<div className="form-group">
											<div className="sign-up-tag-line-wrapper">
												<p>
													Already Have An Account{"? "}
													<a href="/sign-in">( Sign In )</a>
												</p>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
						<div className="col-lg-1"></div>
						<div className="col-lg-7 align-self-center">
							<div className="join-seller-wrapper">
								<div className="join-content-wrapper">
									<h3>
										Join As A <span>APRICOT</span> Seller Program
									</h3>
									<p>
										Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
										diam nonumy eirmod tempor invidunt ut labore et dolore magna
									</p>
									<a href="/sign-up-seller" className="btn">
										Become A Seller
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* sign in ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Sign_up;
